import { Action } from "../global/Action";
import { ActionCentre } from "../global/ActionCentre";
import { TLLPopup } from "../global/TLLPopup";
import { Actions, IAction, IGeocoderSettings, IPopupSettings } from "../global/types";

declare var _gaq: any;

export class TLLMap {
    private actionSvc: ActionCentre;
    private markerLocations: string[] = [];
    private markerLocationURLs: string[] = [];
    private markerLocationLatitudes: string[] = [];
    private markerLocationLongitudes: string[] = [];
    private mainLocation: string;
    private map: google.maps.Map = null;
    private mapVisible: boolean = false;
    private mapActivated: boolean = false;

    constructor(actionsService: ActionCentre) {
        this.actionSvc = actionsService;
        const mainLocation: HTMLElement = document.querySelector("[tll-map-link]") as HTMLElement;

        if (mainLocation) {
            this.bindTriggers();
        }
    }

    private bindTriggers() {
        const mapLink: HTMLElement = document.querySelector("[tll-map-link]") as HTMLElement;
        const mapArea: HTMLElement = document.querySelector("[tll-map-popup]") as HTMLElement;
        const close: HTMLElement = document.querySelector("[tll-map-close]") as HTMLElement; 
        const overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement; 
           
        mapLink.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (this.mapVisible) {
                this.hideMap();
            } else {
                this.showMap();
            }

            if (!this.mapActivated) {
                this.activateMap();
            } 
        });

        mapArea.addEventListener("click", (e) => {
            e.stopPropagation();
        });

        overlay.addEventListener("click", (e) => {
            this.hideMap();
        });

        close.addEventListener("click", (e) => {
            this.hideMap();
        });
    }

    private hideMap() {
        const mapArea: HTMLElement = document.querySelector("[tll-map-popup]") as HTMLElement;
        const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
        this.actionSvc.Do(hideAction);

        mapArea.style.display = "none";
        this.mapVisible = false;
    }

    private showMap() {
        const mapArea: HTMLElement = document.querySelector("[tll-map-popup]") as HTMLElement;
        const showAction = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
        this.actionSvc.Do(showAction);

        mapArea.style.display = "block";
        this.mapVisible = true;

        _gaq.push(["_trackEvent", "Interaction", "Show Map (top level or appropriate)", document.URL, 0, false]);
    }

    private activateMap() {
        this.getMarkerNamesAndDetails();
        this.createMap();
        this.plotMarkers();      
        this.mapActivated = true;      
    }

    private getMarkerNamesAndDetails() {
        const mainLocationEl: HTMLElement = document.querySelector("[tll-map-location-to-plot]") as HTMLElement;
        const markerLocationsEl: NodeListOf<HTMLElement> = document.querySelectorAll("[tll-map-marker]") as NodeListOf<HTMLElement>;
        const markerLocationURLsEl: NodeListOf<HTMLElement> = document.querySelectorAll("[tll-map-marker-url]") as NodeListOf<HTMLElement>;
        const markerLocationLatitudesEl: NodeListOf<HTMLElement> = document.querySelectorAll("[tll-map-marker-lat]") as NodeListOf<HTMLElement>;
        const markerLocationLongitudesEl: NodeListOf<HTMLElement> = document.querySelectorAll("[tll-map-marker-lng]") as NodeListOf<HTMLElement>;

        this.mainLocation = mainLocationEl.getAttribute("tll-map-location-to-plot");

        for (let i = 0; i < markerLocationsEl.length; i++) {
            this.markerLocations.push(markerLocationsEl[i].getAttribute("tll-map-marker"));
            this.markerLocationURLs.push(markerLocationURLsEl[i].getAttribute("tll-map-marker-url"));
            this.markerLocationLatitudes.push(markerLocationLatitudesEl[i].getAttribute("tll-map-marker-lat"));
            this.markerLocationLongitudes.push(markerLocationLongitudesEl[i].getAttribute("tll-map-marker-lng"));
        }
    }

    private createMap() {
        this.map = new google.maps.Map(document.getElementById("tllMap"), {
            scaleControl: true,
        });
    }

    private plotMarkers() {
        const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();

        const iconConfig: google.maps.Icon = {
            url: "/images/responsive2018/misc/pin_original.png",
            size: new google.maps.Size(20, 29),
            scaledSize: new google.maps.Size(20, 29),
        };

        for (let i = 0; i < this.markerLocations.length; i++) {
            const geocoderSettings: IGeocoderSettings = {
                address: `${this.mainLocation}, ${this.markerLocations[i]}`,
                region: this.mainLocation,
            };

            const geocoderSettingsSimple: IGeocoderSettings = {
                address: this.markerLocations[i],
            };

            if (this.checkLatLng(this.markerLocationLatitudes[i], this.markerLocationLongitudes[i])) {
                this.plotLocationsWithKnownLatLng(bounds, iconConfig, i);
            } else {
                this.geocoderFunction(geocoderSettings, i, bounds, geocoderSettingsSimple);                
            }
        }
    }

    private plotLocationsWithKnownLatLng(bounds: google.maps.LatLngBounds, iconConfig: google.maps.Icon, i: number) {
        const positionInfo: google.maps.LatLng = new google.maps.LatLng(parseFloat(this.markerLocationLatitudes[i]), parseFloat(this.markerLocationLongitudes[i]));
        const popup: TLLPopup = new TLLPopup(positionInfo, document.querySelector(`#mapPopupContent${i}`) as HTMLElement);
        popup.setMap(this.map);

        const marker: google.maps.Marker = new google.maps.Marker({
            position: positionInfo,
            icon: iconConfig,
            map: this.map,
            title: `What we offer in ${this.markerLocations[i]}`,
        });

        bounds.extend(marker.getPosition());
        this.map.fitBounds(bounds);        
    }

    private checkLatLng(lat: string, lng: string): boolean {
        if (lat && lng && lat.length > 0 && lng.length > 0) {
            const latValue: number = parseFloat(lat);
            const lngValue: number = parseFloat(lng);

            if (latValue !== 999 && lngValue !== 999) {
                return true;
            }
        } else {
            return false;
        }
        return false;
    }

    private geocoderFunction(geocoderSettings: IGeocoderSettings, i: number, bounds: google.maps.LatLngBounds, geocoderSettingsSimple?: IGeocoderSettings) {
        const geocoder: google.maps.Geocoder = new google.maps.Geocoder();

        const iconConfig: google.maps.Icon = {
            url: "/images/responsive2018/misc/pin_original.png",
            size: new google.maps.Size(20, 29),
            scaledSize: new google.maps.Size(20, 29),
        };

        geocoder.geocode(geocoderSettings, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                const types: string[] = results[0].types;

                if (this.isAllowedType(types)) {
                    const popup = new TLLPopup(results[0].geometry.location, document.querySelector(`#mapPopupContent${i}`) as HTMLElement);
                    popup.setMap(this.map);

                    const marker: google.maps.Marker = new google.maps.Marker({
                        position: {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                        },
                        icon: iconConfig,
                        map: this.map,
                        title: `What we offer in ${this.markerLocations[i]}`,
                    });

                    bounds.extend(marker.getPosition());
                    this.map.fitBounds(bounds);

                } else if (geocoderSettingsSimple) {
                    this.geocoderFunction.bind(this)(geocoderSettingsSimple, i, bounds);
                }
            } else if (status === google.maps.GeocoderStatus.OVER_QUERY_LIMIT) {
                setTimeout(() => { this.geocoderFunction.bind(this)(...arguments); }, 20);                
            } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS && geocoderSettingsSimple) {
                this.geocoderFunction.bind(this)(geocoderSettingsSimple, i, bounds);
            }
        });        
    }

    private isAllowedType(resultArray: string[]): boolean {
        const allowedTypes: string = "locality political postal_town country coloquial_area administrative_area sublocality natural_feature archipelago route";

        for (let i = 0; i < resultArray.length; i++) {
            if (allowedTypes.indexOf(resultArray[i]) > -1) {
                return true;
            }
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/global/TLLMap.ts